import { getAuthHeader } from '.';
import type { AdminReport } from '../models/AdminReport';
import { ROOT_URL } from '../utils/constants';

class AdminApi {
  static async getAdminData(daysSince?: number): Promise<AdminReport[]> {
    const [headers] = await getAuthHeader();
    const url = new URL(`${ROOT_URL}/api/admin`);
    if (daysSince) {
      url.searchParams.append('since', daysSince.toString());
    }
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async getAdminDataForUser(
    userId: string,
    daysSince?: number,
  ): Promise<AdminReport> {
    const [headers] = await getAuthHeader();
    const url = new URL(`${ROOT_URL}/api/admin/${userId}`);
    if (daysSince) {
      url.searchParams.append('since', daysSince.toString());
    }
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: headers,
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
  static async impersonateUser(email: string): Promise<{ token: string }> {
    const [headers] = await getAuthHeader();
    const response = await fetch(`${ROOT_URL}/api/account/impersonate`, {
      method: 'POST',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify({ email }),
    });
    if (!response.ok) {
      throw new Error(`${response.status} ${response.statusText}`);
    }
    return response.json();
  }
}

export default AdminApi;
